/**
 * @module
 *
 * @description Education Loans driver configurations
 */
import { getAccessToAttorneySupport, getAnnualPriceDetails, getAnnualPrice, getPrice, getPriceDetails } from '../selectors/estate-planning';
import { FORMATS, VALUE_SIZES } from '../constants/drivers';
import { formatValue } from '../utils/format';
/**
 * Get the price driver.
 * @param {object} offer - The marketplace offer.
 * @return {object} - The annotation "quick fact" driver.
 */

export var getDriverPrice = function getDriverPrice(offer) {
  return {
    id: 'price',
    label: 'Price (one-time)',
    value: getPriceDetails(offer) || formatValue(getPrice(offer), FORMATS.CURRENCY, true),
    valueSize: VALUE_SIZES.MEDIUM
  };
};
/**
 * Get the annual price driver.
 * @param {object} offer - The marketplace offer.
 * @return {object} - The annotation "quick fact" driver.
 */

export var getDriverAnnualPrice = function getDriverAnnualPrice(offer) {
  return {
    id: 'annualPrice',
    label: 'Price (annual)',
    value: getAnnualPriceDetails(offer) || formatValue(getAnnualPrice(offer), FORMATS.CURRENCY, true),
    valueSize: VALUE_SIZES.MEDIUM
  };
};
/**
 * Get the AccessToAttorneySupport driver.
 * @param {object} offer - The marketplace offer.
 * @return {object} - The annotation "quick fact" driver.
 */

export var getDriverAccessToAttorneySupport = function getDriverAccessToAttorneySupport(offer) {
  return {
    id: 'accessToAttorneySupport',
    label: 'Access to attorney support',
    value: getAccessToAttorneySupport(offer),
    valueSize: VALUE_SIZES.MEDIUM
  };
};